import React from 'react';
import PathManagement from '../../../common/path-management';
import { BrowserRouter as Link, withRouter } from 'react-router-dom';
import Modal from 'react-modal';
import PlanetPlusView from '../../../classes/planet-plus';
import { ToastContainer, toast } from 'react-toastify';
import { isLoggedIn } from '../../../common/entities/usuarios';
import { getResponseByUrl, postResponseByUrl, patchResponseByUrl } from '../../../common/xhr';
import { SHOW_PRICE_DECIMALS } from '../../../common/constants';

class ItemPP extends React.Component {
  constructor(props) {
    super(props);
    let data = this.props.itemData;

    this.state = {
      itemQty: this.props.cartQty ? this.props.cartQty : 1,
      cartQty: this.props.cartQty,
      availableProduct: true,
      inWishlist: false,
      ModalIsOpen: false,
      WishlistModalIsOpen: false,
      itemData: this.props.itemData,
      isPPClient: false,
      userLogged: null,
      showAddToCartPopUp: false,
      noVolverAMostrar: false,
      addCriteria: localStorage.getItem('criterio_agregacion'),
    };

    this.activateCart = this.activateCart.bind(this);
    this.activateWishlist = this.activateWishlist.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.itemData !== prevProps.itemData || this.props.cartQty !== prevProps.cartQty) {
      let data = this.props.itemData;
      let cartQty = this.props.cartQty;
      if (cartQty) {
        this.setState({ itemQty: cartQty });
      } else {
        this.setState({ itemQty: 1 });
      }
      this.setState({ cartQty: cartQty });
      this.setState({ itemData: data });
    }

    if (this.state.userLogged !== prevState.userLogged || this.state.userLogged === null) {
      if (this.state.userLogged !== null) {
        this.checkIsSocioPP();
      }
    }
  }

  componentDidMount() {
    this.getUserLoggedInfo();
  }

  openWishlistModal() {
    this.setState({ WishlistModalIsOpen: true });
  }

  closeWishlistModal() {
    this.setState({ WishlistModalIsOpen: false });
  }

  openModal() {
    if (this.wishlistChecker() === 'active' && this && this.props.loggedInChecked) {
      this.setState({ ModalIsOpen: true });
      this.props.modalState(true);
    }
  }

  closeModal() {
    if (this) {
      this.setState({ ModalIsOpen: false });
      this.props.modalState(false);
    }
  }

  wishlistChecker() {
    if (this.props.wishlistItem && this.props.loggedInChecked && this.props.wishlistItem.length > 0) {
      for (let i = 0; this.props.wishlistItem.length > i; i++) {
        if (this.props.wishlistItem[i].art_id === this.props.itemData.id) {
          return 'active';
        }
      }
    }
  }

  redirectToLoginWishlist() {
    let param1 = this.props.params[0];
    let param2 = this.props.params[1];

    this.props.history.push('/login/login_required/' + param1 + '/' + param2);
  }

  wishlistToaster() {
    let param1 = this.props.params[0];
    let param2 = this.props.params[1];

    if (this.wishlistChecker() !== 'active') {
      if (this.props.loggedInChecked) {
        this.props.toastWishlist('Agregado a favoritos');
      } else if (this.props && param1 && param2) {
        // this.props.history.push('/login/login_required/' + param1 + '/' + param2)
        this.openWishlistModal();
      } else if (this.props) {
        this.props.history.push('/login');
      }
    }
  }

  activateWishlist(event) {
    if (this.props.loggedInChecked) {
      if (event && event.currentTarget.classList.contains('active')) {
        // event.currentTarget.classList.remove('active');
        // alert('Producto quitado de favoritos: ' + this.props.itemData.art_copete);
      } else {
        event.currentTarget.classList.add('active');
        // alert('Producto agregado a favoritos: ' + this.props.itemData.art_copete);
      }
      if (this.props && this.props.addWishlistItem && this.wishlistChecker() !== 'active') {
        this.props.addWishlistItem(this.props.itemData.id);
      }
      if (this.wishlistChecker() === 'active') {
        this.openModal();
        // this.props.deleteWishlistItem(this.props.itemData.id)
      }
    }
  }

  activateCompare(event) {
    if (event.currentTarget.classList.contains('active')) {
      event.currentTarget.classList.remove('active');
    } else {
      event.currentTarget.classList.add('active');
    }
  }

  activateCart() {
    alert('Producto agregado al carrito: ' + this.props.itemData.art_copete);
  }

  showItemColor() {
    if (this.props.itemData.art_color) {
      return (
        <span>
          {' '}
          |{' '}
          <span style={{ textDecoration: 'none', color: 'inherit' }}>
            {this.props.itemData.art_color}
          </span>
        </span>
      );
    }
  }

  formatPrice(priceString) {
    if (priceString) {
      if (SHOW_PRICE_DECIMALS) {
        let trimmedPrice = priceString.replace('$', '').trim();

        let price = parseFloat(trimmedPrice).toLocaleString('es-AR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return `$ ${price}`;
      } else {
        let trimmedPrice = priceString.replace('$', '').trim();

        let price = parseInt(parseFloat(trimmedPrice)).toLocaleString('es-AR', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });

        return `${price}`;
      }
    }
  }

  productSalePrice() {
    if (this.props.itemData.precioOferta_formatted !== '$ 0.00') {
      let priceString = this.props.itemData.ppa_puntos;
      let trimmedPrice = priceString.replace('$', '').trim();

      return (
        <h4 className="product-price">
          <del>{}</del>
          {SHOW_PRICE_DECIMALS ? this.formatPrice(trimmedPrice) : this.formatPrice(trimmedPrice)} Puntos
          {/* <span style={{ fontSize: '10px' }}> + IVA</span> */}
        </h4>
      );
    } else {
      return (
        <h4 className="product-price">
          {SHOW_PRICE_DECIMALS
            ? this.formatPrice(this.props.itemData.precioLista_formatted)
            : this.formatPrice(this.props.itemData.precioLista_formatted)}
          <span style={{ fontSize: '10px' }}> + IVA</span>
        </h4>
      );
    }
  }

  cardClassname() {
    let data = this.props.itemData;
    let defaultClassname = 'product-card mb-30';

    let cartQty = this.state.cartQty;
    if (cartQty) {
      defaultClassname += ' in-cart';
    }
    if (data.destacado) {
      return defaultClassname + ' destacado-border';
    }
    if (data.oferta) {
      return defaultClassname + ' oferta-border';
    }
    if (data.mas_vendido) {
      return defaultClassname + ' vendido-border';
    } else {
      return defaultClassname;
    }
  }

  sellerTag() {
    let data = this.props.itemData;
    if (data.destacado) {
      return (
        <div className="top-card-icon">
          <i className="icon-tag seller-icon blue " />
          <span className="destacado-badge blue">Destacado</span>
        </div>
      );
    }

    if (data.oferta) {
      return (
        <div className="top-card-icon">
          <i className="icon-award seller-icon orange " />
          <span className="destacado-badge orange">Oferta</span>
        </div>
      );
    }

    if (data.mas_vendido) {
      return (
        <div className="top-card-icon">
          <i className="icon-award seller-icon green " />
          <span className="destacado-badge green">Más Vendido!</span>
        </div>
      );
    }

    if (!data.disponible) {
      // this.setState({ itemQty: 1 })
      return <div class="product-badge bg-secondary border-default text-body">No disponible</div>;
    }
    // else {
    //   this.setState({ availableProduct: true })
    // }
  }

  bottomButtons() {
    if (this.props.interactive) {
      return (
        <div className="product-button-group">
          <input
            className="product-button cart-qty"
            type="tel"
            size="3"
            value={this.state.itemQty}
            onChange={(event) => this.setState({ itemQty: event.target.value })}
          ></input>
          {this.addToCartBtn()}
        </div>
      );
    } else return null;
  }

  // async getPPData() {
  //   let planetPlus = new PlanetPlusView();
  //   let res = await planetPlus.getPlanetPlusCtaCte();
  //   if (res) {
  //     if (
  //       res &&
  //       res.statusCode === 200
  //     ) {
  //       this.setState({isPPClient: true});
  //     } else if (res && res.statusCode === 8002) {
  //       this.setState({isPPClient: false});
  //     }
  //   }
  // };

  async checkIsSocioPP() {
    let _pathManager = new PathManagement();
    let url = _pathManager.getIsPlanetPlusSocio(this.state.userLogged.us_cliid);
    let ppSocio;
    try {
      ppSocio = await getResponseByUrl(url);
      if (ppSocio.data) {
        this.setState({ isPPClient: true });
      } else {
        this.setState({ isPPClient: false });
      }
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de socio planet plus');
    }
  }

  async getUserLoggedInfo() {
    const loginRes = await isLoggedIn();
    if (loginRes) {
      this.setState({ userLogged: loginRes });
    }
  }

  async addToCart(id, copete, pplus) {
    if (this.state.cartQty <= 0) {
      let res = await this.props.onCartChange(id, this.state.itemQty, pplus);
      if (res && res.statusCode === 200) {
        this.props.toastCart(copete, this.state.itemQty);
      }
    } else {
      if (this.state.addCriteria === 'REEMPLAZAR') {
        this.replaceQty(id, copete, pplus);
      } else if (this.state.addCriteria === 'SUMAR') {
        this.addQty(id, copete, pplus);
      } else {
        this.setState({ showAddToCartPopUp: true });
      }
    }
  }

  async replaceQty(id, copete, pplus) {
    if (this.state.noVolverAMostrar) {
      localStorage.setItem('criterio_agregacion', 'REEMPLAZAR');
      this.setState({ addCriteria: 'REEMPLAZAR' });
    }
    let res = await this.props.onCartChange(id, this.state.itemQty, pplus);
    if (res && res.statusCode === 200) {
      this.props.toastCart(copete, this.state.itemQty);
      this.setState({ showAddToCartPopUp: false });
    }
  }

  async addQty(id, copete, pplus) {
    if (this.state.noVolverAMostrar) {
      localStorage.setItem('criterio_agregacion', 'SUMAR');
      this.setState({ addCriteria: 'SUMAR' });
    }
    let qty = +this.state.cartQty + +this.state.itemQty;
    let res = await this.props.onCartChange(id, qty, pplus);
    if (res && res.statusCode === 200) {
      this.props.toastCart(copete, qty);
      this.setState({ showAddToCartPopUp: false });
    }
  }

  addToCartBtn() {
    let data = this.props.itemData;
    let cartQty = this.props.cartQty;
    if (this.props.onCartChange && this.props.toastCart) {
      return (
        <span
          className={cartQty ? 'product-button active-cart-icon cursor-pointer' : 'product-button'}
          onClick={() => {
            if (!this.state.isPPClient) {
              toast.error(
                'No puede agregar productos del catálogo Planet Plus a menos que esté afiliado al programa'
              );
            } else {
              this.addToCart(data.ppa_id, this.state.itemQty, true);
            }
          }}
          title={cartQty ? `El artículo ya está en el carrito (${cartQty})` : ''}
        >
          <i className="icon-shopping-cart"></i>
          <span>Al carrito</span>
        </span>
      );
    } else {
      return (
        <span className="product-button">
          <i className="icon-shopping-cart red"></i>
          <span>No disponible</span>
        </span>
      );
    }
    // }
    // else{
    //   return null
    // }
  }

  getArticuloUrl() {
    const articuloCopete = this.props.itemData.ppa_copete.replace(/[\s,#]+/g, '-'); //Reemplaza comas y espacios por guiones
    const articuloId = '#' + this.props.itemData.ppa_id;
    const url = '/articulo/' + articuloCopete + articuloId;
    return url;
  }

  customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
    },
  };

  render() {
    let _pathManager = new PathManagement();
    let imgURL = _pathManager.getImgURL();
    return (
      <div
        className={
          this.props.forCarousel
            ? 'mt-3 col-md-' + this.props.rowSize
            : 'col-md-' + this.props.rowSize + ' col-sm-6'
        }
      >
        <div className={this.cardClassname()}>
          {/* <h3 className='card-title' >{this.props.itemData.ppam_nombre}</h3 > */}
          {/* {this.sellerTag()} */}
          <Link className="product-thumb" to={this.getArticuloUrl()}>
            {imgURL + this.props.itemData.imagen_1_src ? (
              <img
                src={imgURL + this.props.itemData.ppai_imagen}
                alt="Product"
                title={
                  this.props.itemData.art_descripcion
                    ? this.props.itemData.art_descripcion
                    : this.props.itemData.ppa_descripcion
                }
                style={{ minHeight: '180px' }}
                priority="true"
              />
            ) : (
              <div>
                <p className="text-center not-found-img">Imagen no disponible</p>
              </div>
            )}
          </Link>
          <div className="product-card-body" style={{height: '185px'}}>
            <div className="product-category">
              <span>{this.props.itemData.ppa_id}</span>
            </div>
            <div className="product-category"></div>
            <h3 className="product-title">
              <Link to={this.getArticuloUrl()}>{this.props.itemData.ppa_copete}</Link>
            </h3>
            {this.productSalePrice()}
          </div>
          {this.bottomButtons()}
        </div>
        <Modal
          isOpen={this.state.WishlistModalIsOpen}
          onRequestClose={this.closeWishlistModal}
          style={this.customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h4 className="modal-title text-white">Iniciar sesión</h4>
              <button
                onClick={() => {
                  this.closeWishlistModal();
                }}
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Para utilizar la función de favoritos es necesario iniciar sesión</p>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.closeWishlistModal();
                }}
                className="btn btn-outline-secondary btn-sm"
                type="button"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  this.closeWishlistModal();
                  this.redirectToLoginWishlist();
                }}
                className="btn btn-primary btn-sm"
                type="button"
                data-dismiss="modal"
              >
                Iniciar sesión
              </button>
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.ModalIsOpen} onRequestClose={this.closeModal} style={this.customStyles}>
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h4 className="modal-title text-white">Eliminar</h4>
              <button
                onClick={() => {
                  this.closeModal();
                }}
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>El producto se eliminirá de favoritos. ¿Estás seguro?</p>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.closeModal();
                }}
                className="btn btn-outline-secondary btn-sm"
                type="button"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  this.props.deleteWishlistItem(this.props.itemData.id);
                  this.closeModal();
                  this.props.toastWishlist('Removido de favoritos');
                }}
                className="btn btn-primary btn-sm"
                type="button"
              >
                Eliminar
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.showAddToCartPopUp}
          onRequestClose={() => {
            this.setState({ showAddToCartPopUp: false });
          }}
          contentLabel="AddToCart Modal"
          style={this.customStyles}
        >
          {this.state.showAddToCartPopUp && (
            <div className="modal-large" role="document">
              <div className="modal-content">
                <div className="modal-header bg-primary">
                  <h4 className="modal-title text-white">
                    <i className="icon-shopping-cart" />
                    {' Agregar al carrito'}
                  </h4>
                </div>
                <div
                  className="modal-footer pt-4"
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                >
                  <div>
                    El articulo ya se encuentra en el carrito. <br />
                    Elegi si queres agregar o reemplazar la cantidad seleccionada.
                  </div>
                  <div className="mt-2" style={{ width: '100%' }}>
                    <div style={{ float: 'left' }}>
                      <input
                        className="btn btn-sm btn-secondary"
                        type="checkbox"
                        onChange={() => {
                          this.setState({ noVolverAMostrar: !this.state.noVolverAMostrar });
                        }}
                        checked={this.state.noVolverAMostrar}
                      />
                      <span className="ml-2">No volver a preguntar</span>
                    </div>
                    <div style={{ float: 'right' }}>
                      <button
                        className="btn btn-sm btn-secondary"
                        type="button"
                        onClick={() => {
                          this.setState({ showAddToCartPopUp: false });
                        }}
                      >
                        <span className="cart-icon">
                          <i className="icon-x" />
                          {' Cancelar'}
                        </span>
                      </button>
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={() => {
                          this.addQty(this.props.itemData.ppa_id, this.state.itemQty, true);
                        }}
                      >
                        <span className="cart-icon">
                          <i className="icon-plus" />
                          {` Agregar (${+this.state.cartQty + +this.state.itemQty})`}
                        </span>
                      </button>
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={() => {
                          this.replaceQty(this.props.itemData.ppa_id, this.state.itemQty, true);
                        }}
                      >
                        <span className="cart-icon">
                          <i className="icon-refresh-cw" />
                          {`  Reemplazar  (${this.state.itemQty})`}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>

        {/* <ProductStructuredData product={this.state.itemData} /> */}
      </div>
    );
  }
}

export default withRouter(ItemPP);
